import { Button } from '@amzn/stencil-react-components/button';
import { Select } from '@amzn/stencil-react-components/select';
import { Row, Spacer, View } from '@amzn/stencil-react-components/layout';
import { Label, Text } from '@amzn/stencil-react-components/text';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { updateJourneySegment } from '../../actions/journeyDetailsAction';
import { CREATE_SEGMENT_PAGE } from '../../constants/routesConstant';
import { segmentListSelector } from '../../selectors/selectors';
import { buildSegmentListOption, segmentListFilter } from '../../util/campaign/campaignUtils';
import { accessById as segmentValueAccessor } from '../../util/journey/journeyUtils';

const SelectSegment = ({ data, id, readonly }) => {
  const history = useHistory();
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const segmentList = useSelector(segmentListSelector);
  const buildSegmentList = buildSegmentListOption(segmentList);

  const segmentsRenderOption = option => (
    <Row display="flex" flexDirection="column" gridGap="S200">
      <Row alignItems="center">{option?.name}</Row>
      {option?.description && (
        <Row display={'flex'} gridGap="S200" fontSize="T100" color="neutral70">
          <Text fontSize="T100">Description: </Text>
          <Text fontSize="T100">{option.description}</Text>
        </Row>
      )}
      <Text fontSize="T100" color="neutral70">
        {option?.createdBy && (
          <Row display={'flex'} gridGap="S200" flexDirection="row">
            <Text fontSize="T100">Created by: </Text>
            <Text fontSize="T100" style={{ fontWeight: 'bold' }}>
              {option?.createdBy}
            </Text>
          </Row>
        )}
      </Text>
    </Row>
  );

  const segmentFilterOption = searchText => segmentListFilter(searchText, buildSegmentList);

  const onSegmentSelect = e => {
    const value = {
      segmentName: e.name,
      segmentId: e.id,
    };
    dispatch(updateJourneySegment(id, { ...value }));
  };

  return (
    <>
      <Label fontSize="T300" fontWeight="bold">
        <FormattedMessage id="app.selectSegment.segment" defaultMessage="Segment" />
      </Label>
      <Spacer height="15px" />
      <Select
        error={false}
        key={id}
        data-testid="segment-selector"
        isMulti={false}
        isSearchable={true}
        labelId="choose-template-label"
        disabled={readonly}
        onChange={e => onSegmentSelect(e)}
        options={buildSegmentList}
        valueAccessor={segmentValueAccessor}
        renderOption={segmentsRenderOption}
        filterOptions={segmentFilterOption}
        noOptionsText={formatMessage({ id: 'app.selectTemplate.noOption' })}
        placeholder={formatMessage({ id: 'app.selectSegment.segment' })}
      />
      <View display="flex" justifyContent="start">
        <Button
          fontSize="T500"
          color="primary05"
          key={id}
          data-testid="or-create-segment-link"
          disabled={readonly}
          variant="tertiary"
          onClick={() => history.push(CREATE_SEGMENT_PAGE)}
          css={{paddingLeft: 0}}
        >
          <FormattedMessage
            id="app.selectSegment.orCreateANewSegment"
            defaultMessage="or create a new segment"
          />
        </Button>
      </View>
    </>
  );
};

export default SelectSegment;
